import React, { useEffect, useState } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';
import LoadingContext from './contexts/LoadingContext';
import Loader from './components/Loader';
import { initializeSession } from './utils/api';

// Use full URL for cross-origin requests
const FRAPPE_URL = process.env.REACT_APP_FRAPPE_URL || 'http://pra.localhost:8000';

function App() {
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  // Check localStorage for login state (fallback for cross-origin cookie issues)
  useEffect(() => {
    const checkAuth = async () => {
      const localLoggedIn = localStorage.getItem('frappe_logged_in') === 'true';
      
      if (localLoggedIn) {
        // If user appears to be logged in, initialize session
        try {
          const sessionResult = await initializeSession();
          if (sessionResult.success) {
            console.log('✓ Session initialized on app startup');
          } else {
            console.warn('⚠️ Session initialization failed on startup:', sessionResult.error);
          }
        } catch (error) {
          console.warn('⚠️ Error during startup session initialization:', error);
        }
      }
      
      setIsLoggedIn(localLoggedIn);
      setIsCheckingAuth(false);
    };
    
    checkAuth();
  }, []);

  if (isCheckingAuth) {
    return (
      <div className="loading-logo-container">
        <img
          src={process.env.PUBLIC_URL + '/pragyaa-logo.png'}
          alt="Pragyaa Logo"
          className="animated-logo"
        />
      </div>
    );
  }

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {/* global loader — controlled via LoadingContext */}
      <Loader visible={loading} message={loading ? 'Please wait...' : 'Loading...'} />
      {isLoggedIn ? <Dashboard /> : <Login />}
    </LoadingContext.Provider>
  );
}

export default App;